import React, { forwardRef } from 'react';
import { makeStyles, Button, CircularProgress } from '~/lib/bn-material-ui';

const useStyles = makeStyles(({ palette }) => {
  return ({
    loadingProgress: {
      color: `${palette.gray[50]} !important`,
    },
  });
});

// For Material v5, delete this file and use LoadingButton instead
const BnLoadingButton = forwardRef(function BnLoadingButton({ children, loading, startIcon, disabled, ...props }, ref) {
  const styles = useStyles();
  return (
    <Button {...props} ref={ref} disabled={Boolean(loading || disabled)} startIcon={loading ? <CircularProgress className={styles.loadingProgress} size='1em' /> : startIcon}>
      {children}
    </Button>
  );
});

export default BnLoadingButton;
